import React from 'react'

import * as S from './styles'

const Background = () => {
  return <S.Wrapper></S.Wrapper>
}

export default Background
